import type {Comment, Thread, ThreadSubject} from '@github-ui/diff-lines/conversation-types'

type CommentAuthor = {
  avatarUrl: string
  login: string
}

type CommentPreviews = {
  author?: CommentAuthor | null
}

export type PreviewInfo = {
  threadId: string
  commentId: string
  path: string
  threadPreviewComments: CommentPreviews[]
  originalDiffPathUri?: string | null
  firstComment?: Comment
  subject?: ThreadSubject
  line?: number | null
  isOutdated?: boolean
}

export type ThreadPreview = Pick<Thread, 'isResolved' | 'line' | 'subjectType' | 'subject' | 'commentsData'> & {
  threadId: string
  isOutdated?: boolean
  commentId: string
  path: string
  //TODO: deprecate threadPreviewComments
  threadPreviewComments: CommentPreviews[]
  originalDiffPathUri?: string | null
  firstComment?: Comment
}

export type ThreadPreviewComp = {
  thread: Thread
  previewInfo: PreviewInfo
}

export type ThreadPreviewsPayload = ThreadPreview[]
export type ThreadPreviewsCompPayload = ThreadPreviewComp[]

// Type guard to check if an item is ThreadPreviewComp
export function isThreadPreviewComp(item: unknown): item is ThreadPreviewComp {
  return item !== null && typeof item === 'object' && 'previewInfo' in item
}

export function getFirstComment(thread: Thread): Comment | undefined {
  return thread.commentsData?.comments?.[0]
}

// Transform ThreadPreview to Thread
export function transformThreadPreviewToThread(threadPreview: ThreadPreviewComp): Thread {
  const thread: Thread = {
    id: threadPreview.previewInfo.threadId,
    isOutdated: threadPreview.previewInfo.isOutdated,
    line: threadPreview.previewInfo.line,
    subject: threadPreview.previewInfo.subject,
    commentsData: threadPreview.previewInfo.firstComment
      ? {comments: [threadPreview.previewInfo.firstComment]}
      : undefined,
    commentCount: threadPreview.previewInfo.threadPreviewComments.length,
    path: threadPreview.previewInfo.path,
    originalDiffPathUri: threadPreview.previewInfo.originalDiffPathUri,
  }

  return thread
}
